import { UniqueIdentifier } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { useTheme } from "@emotion/react";
import { faGripDotsVertical } from "@fortawesome/pro-light-svg-icons";
import { Row } from "@tanstack/react-table";
import React, { ReactNode } from "react";
import Button from "../Button";
import Flex from "../Flex";
import Icon from "../Icon";

interface Props<TData extends Record<string, unknown>> {
  children?: ReactNode;
  row: Row<TData>;
}

export function RowDragHandleCell<TData extends Record<string, unknown>>(
  props: Props<TData>
) {
  const theme = useTheme();

  const { attributes, listeners } = useSortable({
    id: props.row.original.id as UniqueIdentifier,
  });

  return (
    <Flex alignItems="center" gap={theme.space_xs}>
      <Button
        cursor="grab"
        dndAttributes={attributes}
        dndListeners={listeners}
        iconEnd={<Icon icon={faGripDotsVertical} />}
        size="small"
        type="button"
      />
      {props.children}
    </Flex>
  );
}
